<template>
  <div class="bg-primary request-service">
    <div class="container mx-auto px-3 py-8 lg:py-20 px-8 flex flex-col lg:flex-row lg:gap-8 gap-5">
      <div class="flex flex-col lg:gap-5 gap-4 text-white lg:max-w-[50%] w-full mt-5">
        <div class="text-lg uppercase">BOOK US NOW</div>
        <div class="text-5xl font-semibold font-primary">Request Service Now!
        </div>
        <div class="text-base ">Ready to experience top-notch service? Look no further! Book our services today and let us
          take care of your needs. Here's why you should choose us.</div>
        <div class="lg:mt-5 mt-3">
          <ul class="flex flex-col gap-3 lg:gap-5 lg:mt-5">
            <li class="flex gap-2" v-for="item, index in data" :key="index">
              <span v-html="tick_mark" class="p-1 bg-secondary rounded-full flex items-center max-h-[24px]"></span>
              <div><span>{{ item }}</span></div>
            </li>
          </ul>
        </div>
      </div>
      <div class=" flex justify-center align-center lg:max-w-[50%] w-full mt-5">
        <div class="relative w-full">
          <div class="hidden lg:block absolute bg-secondary w-[30%] h-[10%] -top-3 -right-3"></div>
          <div class="bg-white p-5 relative">
            <div class="font-bold font-primary text-2xl mb-3">Get Free Consultation </div>
            <Form />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Form from "../Form/Index.vue";
const data = ["Enjoy 24/7 service.", "Workmanship is Always Guaranteed!", "You'll receive Free Estimates.", "Dedicated Customer Service.", "We offer Financing options."];
const tick_mark = `<svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.666 0.235435C15.0892 0.591712 15.1433 1.22347 14.7871 1.64646L6.77505 11.1607C6.41056 11.5938 5.75971 11.6387 5.33905 11.26L0.331476 6.75328C-0.0796235 6.38326 -0.11284 5.75001 0.257035 5.33891C0.627059 4.92781 1.26031 4.89447 1.6714 5.26447L5.90949 9.07871L13.255 0.356347C13.6111 -0.0666587 14.243 -0.120804 14.666 0.235465L14.666 0.235435Z" fill="#005CFF"/>
</svg>`;
</script>
<style scoped>
.request-service {
  background-image: url("../../assets/v-1.1/req-service-banner.webp");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>